import React from "react";
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import CalendarEventFileDialog from "./CalendarEventFileDialog.js";

const styles = theme => ({
  downloadCalenarDialogContainer: {
    height: "auto",
    position: "relative"
  }
});

class ChooseCalendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlertModal: false,
      courseTitle: "",
      courseDescription: "",
      linkToTheFirstActivity: "",
      calendarTitle: "",
      courseId: "",
      duration: "",
      dtStart: "",
      dtEnd: "",
      allDay: false
    };
  }

  goToCalendar(
    calendarAppLink,
    title,
    courseTitle,
    courseDescription,
    linkToTheFirstActivity,
    courseId,
    duration,
    dtStart,
    dtEnd,
    allDay
  ) {
    if (calendarAppLink) {
      window.open(calendarAppLink, "_blank");
    } else if (
      !calendarAppLink &&
      (title === "Outlook Calendar" || title === "iCal")
    ) {
      this.setState({
        showAlertModal: true,
        calendarTitle: title,
        courseTitle: courseTitle,
        courseDescription: courseDescription,
        linkToTheFirstActivity: linkToTheFirstActivity,
        courseId: courseId,
        duration: duration,
        dtStart: dtStart,
        dtEnd: dtEnd,
        allDay: allDay
      });
    }
  }

  closeAlertModal() {
    this.setState({ showAlertModal: false });
  }

  render() {
    const { calendarApps } = this.props;
    const { classes } = this.props;

    if (!calendarApps?.length) {
      return <Typography>There are no calendar items</Typography>;
    }

    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Dialog
            classes={{
              container:
                "downloadCalenarDialogContainer " +
                classes.downloadCalenarDialogContainer
            }}
            open={this.state.showAlertModal}
            onClose={() => this.closeAlertModal()}
            maxWidth="lg"
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Download Calendar Event
              <IconButton
                edge="start"
                style={{ position: "absolute", right: 1, top: 1 }}
                onClick={() => this.closeAlertModal()}
                aria-label="Close"
                size="large"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 50, paddingBottom: 50 }}>
              <CalendarEventFileDialog
                calendarTitle={this.state.calendarTitle}
                courseTitle={this.state.courseTitle}
                courseDescription={this.state.courseDescription}
                linkToTheFirstActivity={this.state.linkToTheFirstActivity}
                duration={this.state.duration}
                dtStart={this.state.dtStart}
                dtEnd={this.state.dtEnd}
                allDay={this.state.allDay}
                courseId={this.state.courseId}
                onClose={() => this.closeAlertModal()}
              />
            </DialogContent>
          </Dialog>

          <FormControl component="fieldset">
            <RadioGroup aria-label="CalendarApp" name="calendarApp">
              {calendarApps.map((calendarApp, index) => {
                return (
                  <FormControlLabel
                    key={calendarApp.title}
                    value={String(calendarApp.title)}
                    control={<Radio />}
                    label={calendarApp.title}
                    onClick={() =>
                      this.goToCalendar(
                        calendarApp.value,
                        calendarApp.title,
                        calendarApp.courseTitle,
                        calendarApp.courseDescription,
                        calendarApp.linkToTheFirstActivity,
                        calendarApp.courseId,
                        calendarApp.duration,
                        calendarApp.dtStart,
                        calendarApp.dtEnd,
                        calendarApp.allDay
                      )
                    }
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item md={2} xs={6}>
          <FormControl>
            <Button
              value="Close"
              letiant="outlined"
              variant="outlined"
              onClick={() => this.props.onClose()}
              aria-label="Close"
            >
              Close
            </Button>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ChooseCalendar);
